import store from './reducers/store'
import { setImagesAction, reset, clearResults } from './reducers/reducers'
import { database } from './firebase'
import _ from 'underscore'

const imagedb = database.ref('images')

const MAX_IMAGE_COUNT = 12

function init() {
	imagedb.once('value').then(function(snapshot) {
	    const imageSnapshot = snapshot.val()
	    const images = Object.keys(imageSnapshot).map(key => ({
	        id: key,
	        ...imageSnapshot[key]
	    }))

	    store.dispatch(reset())
	    store.dispatch(setImagesAction(_.shuffle(images).slice(0, MAX_IMAGE_COUNT)))
	    store.dispatch(clearResults())
	})
}

export default init

export { MAX_IMAGE_COUNT }



// WEBPACK FOOTER //
// ./src/init.js